<div class="loader-overlay" *ngIf="(isLoading$ | async)">
  <div class="spinner"></div>
</div>

